var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "renwufwlist" }, [
    _c(
      "div",
      { staticClass: "list" },
      [
        _vm._l(_vm.list, function (house, index) {
          return _c(
            "div",
            { key: index },
            [
              house.type == "新房"
                ? _c("houseItemNew", {
                    attrs: { house: house, type: _vm.$route.query.type },
                    on: { handleHosue: _vm.handleHosue },
                  })
                : _c("house-item", {
                    attrs: { house: house, type: _vm.$route.query.type },
                    on: { handleHosue: _vm.handleHosue },
                  }),
            ],
            1
          )
        }),
        _vm._v(" "),
        _vm.hasMore
          ? _c("div", { staticClass: "next", on: { click: _vm.nextPage } }, [
              _vm._v("下一页"),
            ])
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _vm.list.length == 0
      ? _c("div", { staticClass: "list-null" }, [_vm._v("暂无数据")])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "btn-complete", on: { click: _vm.complete } }, [
      _vm._v("客户确认"),
    ]),
    _vm._v(" "),
    _vm.$route.query.khzt != "已确认"
      ? _c("div", {
          staticClass: "add-fw",
          attrs: { id: "addFw" },
          on: {
            click: _vm.addFw,
            touchstart: _vm.touchstart,
            touchmove: _vm.touchmove,
            touchend: _vm.touchend,
          },
        })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }